export default __webpack_public_path__ + "static/media/mgj.91e72bbd.png";